import TrainlineTrainIcon from './TrainlineTrainIcon';

export default TrainlineTrainIcon;